<template>
    <div class="TarinSecondPageWarp">
        <div class="menubox">
            <NavMenu/>
        </div>
        <!-- <el-image :src="img1" class="imgbox"></el-image> -->
        <!-- <div style="background: rgba(68, 141, 247, 0.08);">
            
            <div class="crumbsBox">
                <div>
                    您当前所在位置：{{currentMenu}}-{{tabactiveTitle}}
                </div>
            </div>
        </div> -->
        <div class="commoncrumbsBox">
            <img :src="img1" alt="" class="topimgbox" >
            <div class="pagetopbox">
                <div class="crumbsBox">
                    <div>
                        您当前所在位置：{{currentMenu}}-{{tabactiveTitle}}
                    </div>
                </div>
            </div>
        </div>
        <div class="contentWarp">
            <div class="tabsWarp">
                <router-link v-for="(item,index) in tabsList" :key="index" class="tabItemBox" active-class="nav-link" :to="item.url" @click.native="jump(item)">
                    <span :class="tabactiveTitle==item.name?'activetext':'text'">{{item.name}}</span>
                </router-link>
                <!-- 路由跳转之前没有清除session -->
            </div>
            <div class="componentBox">
                <router-view />
            </div>
        </div>
        <div class="footerbox">
            <Footer/>
        </div>
        <!--  领军人才报名-->
        <!-- <LeadSingupModal :isShow.sync="leadsingupVisible" v-if="leadsingupVisible" @offseconfModal='offseconfModal' :leartrainData='leartrainData'
        /> -->
    </div>
</template>
<script>
import NavMenu from '@/components/navMenu.vue'
import Footer from '@/components/footer.vue'
// import LeadSingupModal from '../LeadSingupModal'
import { httpService, srcUrl } from "@/service/httpService";
export default {
    components: {
        NavMenu,
        Footer,
        // LeadSingupModal
    },
    data() {
        return {
            img1: require("@/assets/imgs/lead/img3.png"),
            srcUrl: srcUrl,
            tabsList: [
                { name: '培训报名', url: "/tarin-secondpage/tarin-course" },
                { name: '培训通知', url: "/tarin-secondpage/tarin-inform" },
                { name: '课程培训', url: "/tarin-secondpage/tripartite-train" },
                // { name: '精选课程', url: "/tarin-secondpage/choiceness-course" },
            ],
            tabactiveTitle: '培训报名',
            currentMenu: sessionStorage.getItem('clickMenu'),
            // islogin: sessionStorage.getItem('token'),
            // leartrainData: null,
            // leadsingupVisible:false,
        }
    },
    watch: {
        $route: {
            handler: function (val, oldVal) {
                this.tabactiveTitle = val.meta.title
            },
            deep: true,
            immediate: true,
        },
    },
    mounted() {
        // 获取领军人才课程信息
        // this.getlearInfo()
    },
    methods: {
        // async getlearInfo() {
        //     httpService.getLeaderClass().then(res => {
        //         if (res.code == 200) {
        //             this.leartrainData = res.result
        //             this.status = res.result.status
        //         } else {
        //             this.$message.error(res.message);
        //         }
        //     })
        // },
        // singupFn() {
        //     if (!this.islogin) {
        //         this.$message({
        //             message: '请先登录网站',
        //             type: 'warning'
        //         });
        //     } else {
        //         // 1提交 2审核通过 3审核失败
        //         // 現在判断是否能继续报名的状态还没有返回，auditResult是错误的
        //         if (!this.leartrainData.flag) {
        //             this.$message({
        //                 message: '您已报名成功，请等待审核，报名信息请移至【账户中心】下的【培训课程管理】进行查看',
        //                 type: 'warning'
        //             });
        //         } else {
        //             this.leadsingupVisible = true
        //         }
        //         //  this.singupVisible = true
        //     }
        // },
        jump(item) {
            // console.log(this.$route.meta.title,'this.$route.meta');
            this.tabactiveTitle = this.$route.meta.title;
            sessionStorage.removeItem('currentNew')
            sessionStorage.removeItem('childMenuObj')
        },
    },
    filters: {
        timer: (value) => {
            return value.substring(0, 10);
        },
    },
}
</script>
<style lang="less" scoped>
.TarinSecondPageWarp {
	width: 100%;
	margin: 0 auto;
	.imgbox {
		width: 100%;
		// height: 605px;
	}
	.menubox {
		width: 100%;
	}
	.crumbsBox {
		// width: 100%;
		width: 1200px;
		margin: 0 auto;
		background: rgba(68, 141, 247, 0.03);
		padding: 19px 0 19px 0px;
		color: #448df7;
	}
    
	.topimgbox {
		width: 100%;
		height: 300px;
	}
    .commoncrumbsBox {
		width: 100%;
		position: relative;
		.topimgbox {
			width: 100%;
			// height: 300px;
            // cursor: pointer;
		}
		.pagetopbox {
			width: 100%;
			margin: 0 auto;
			background: rgba(51, 51, 51, 0.23);
			box-sizing: border-box;
			position: absolute;
			bottom: 5px;
			left: 0px;
			.crumbsBox {
				width: 1200px;
				margin: 0 auto;
				padding: 20px 0 20px 0px;
				color: #fff;
			}
		}
	}
	.contentWarp {
		width: 1200px;
		// min-height: 1000px;
		min-height: 600px;
		margin: 0 auto;
		.componentBox {
			margin: 40px 0 0px 0;
		}
	}
}
</style>


